import Aos from "aos";
import React, { useEffect } from "react";
import NumberCounter from "../NumberCounter";

const Stats = () => {
  const stats = [
    {
      title: "30",
      desc: "YEARS OF <br> EXPERIENCE",
    },
    {
      title: "6",
      desc: "PROJECTS  <br> FEATURED",
    },
    {
      title: "10",
      addPlus: true,
      desc: "ACTIVE <br> BLOCKBUSTERS",
    },
    {
      title: "500",
      startFrom: 450,
      addPlus: true,
      desc: "ADVERTISEMENTS <br> MADE",
    },
  ];

  return (
    <section
      className="w-full px-4 mt-[60px] md:px-[7.2vw] md:mt-[100px] 3xl:mt-[120px] bg-white/15 backdrop-blur-xl py-[40px] sm:py-[90px]"
      data-aos="fade-up"
    >
      <div className="stats grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-12">
        {stats?.map(({ title, desc, addPlus, startFrom }, i) => (
          <div
            className="stat flex text-center xl:text-left flex-col"
            key={`stat-${i}`}
          >
            {/* <h2 className="w-full text-[100px] leading-[90px] sm:text-[120px] sm:leading-[100px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
              {title}
            </h2> */}
            <NumberCounter
              targetNumber={title}
              startFrom={startFrom}
              customCss={
                "w-full text-[100px] leading-[90px] sm:text-[120px] sm:leading-[100px] 3xl-plus:text-[140px] 3xl-plus:leading-[150px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
              }
              addPlus={addPlus}
            />
            <p
              className="w-full 3xl-plus:text-[60px] 3xl-plus:leading-[70px] sm:text-[50px] text-[32px] leading-[32px] font-bebas_neue text-white sm:leading-[50px] mt-5 sm:mt-9"
              dangerouslySetInnerHTML={{ __html: desc }}
            ></p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
